<script module lang="ts">
  import type { ProductVariant } from "@agapi/mlc-core";

  export interface ProductImageGalleryProps {
    variants: ProductVariant[];
  }
</script>

<script lang="ts">
  import { css } from "@agapi/ui/panda/css";
  import { Carousel, CarouselSlide } from "@agapi/ui/carousel";
  import { Image } from "@agapi/ui/image";

  const { variants }: ProductImageGalleryProps = $props();
</script>

<Carousel
  options={{
    slidesToScroll: 1,
    align: 'start'
  }}
  rootStyles={css.raw({ minWidth: { base: '100%', md: '40%' } })}
>
{#each variants.flatMap((variant) => variant.images) as image, index}
  <CarouselSlide fullWidth css={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    {#key image.url}
      <Image
        src={image.url}
        alt={`${variants[0].name} - ${variants[0].brand.name}`}
        background="{image.url}?width=8"
        width={700}
        aspectRatio={1}
        fit="contain"
        fetchpriority={index === 0 ? 'high' : 'auto'}
        loading={index === 0 ? 'eager' : 'lazy'}
      />
    {/key}
  </CarouselSlide>
{/each}
</Carousel>
